<template>
  <bk-page class="memberRightsPage" pageType="navPage" :navBarInfo="navBarInfo" :loading="loadView==='view'">
    <bk-view class="view-content">
			<bk-view class="view-tabs-mian">
				<bk-tabs
					v-model:value="formData.status"
					:data-list="tabsList"
				/>
			</bk-view>
			<bk-view class="view-shop-list">
				<bk-view class="view-item" v-for="item in calcDataList" :key="item.id">
					<bk-view class="view-header">
						<bk-view class="view-header-left">
							<bk-icon icon="icon-mendian"></bk-icon>
							<bk-view class="view-compName">{{item.saleCompName}}</bk-view>
						</bk-view>
						<bk-view class="view-header-right">
							<bk-button  v-if="systemInfo[item.saleCompId] && systemInfo[item.saleCompId]['MASE119']" langCode="userInfo_memberRights_book" @click="handleBook(item)"></bk-button>
						</bk-view>
					</bk-view>

					<bk-view class="view-right-list">
						<bk-view class="view-right-item" v-for="rightItem in item.list"  :key="rightItem.id"  @click="handleItemClick(rightItem, item.currencySymbol)">
							<rightItemCard :rightType="rightType" :rightItem="rightItem" :currencySymbol="item.currencySymbol" />
						</bk-view>
					</bk-view>
				</bk-view>
				<bk-empty v-if="!calcDataList.length" center :langCode_description="emptyDescription"></bk-empty>
			</bk-view>
    </bk-view>

		<transition name="rightFadeIn">
      <rightsDetail v-if="showPage=='rightsDetail'" :curRows="curItem" :systemInfo="systemInfo" :currencySymbol="currencySymbol" :rightType="rightType" @close="setShowPage()" />
    </transition>

	</bk-page>
</template>

<script>
	import rightItemCard from './components/rightItemCard/rightItemCard.vue';
	import { customerReq, baseReq } from '@/reqService';
	import rightsDetail from './rightsDetail/rightsDetail.vue';

	export default {
		name: 'memberRights',
		components:{ rightItemCard, rightsDetail },
		props:{
			rightType:String,
		},
		data (){
			return {
				systemInfo:{},
				dataList:[],
				showPage:'',
				curItem:null,
				userInfo:this.$bk_getUserInfo(),
				formData:{
					status:1,
				},
				statistics:{},
				loadView:'',
				currencySymbol:'',
				shopDetailInfo: this.$bk_getShopDetailInfo(),
			};
		},
		computed:{
			calcDataList (){
				const { status } = this.formData;
				
				return this.dataList.filter((item) => {
					item.list = (item.rightsList || []).filter((rightsItem) => {
						return rightsItem.status == status;
					});
					return item.list?.length;
				});
			},
			tabsList (){
				const lang = this.$bk_lang;
				const { activeNum=0, exhaustedNum=0, expiredNum=0, inactiveNum=0 } = this.statistics;

				return [
					{label:`${lang['userInfo_memberRights_active']} (${activeNum})`, key: 1 },
					{label:`${lang['userInfo_memberRights_inactive']} (${inactiveNum})`, key: 2 },
					{label:`${lang['userInfo_memberRights_exhausted']} (${exhaustedNum})`, key: 3 },
					{label:`${lang['userInfo_memberRights_expired']} (${expiredNum})`, key:4 },
				];
			},
			emptyDescription (){
				return `userInfo_memberRights_description_${this.rightType}`;
			},
			navBarInfo (){
				return {
					langCode_title:`userInfo_memberRights_${this.rightType}`,
					backFlag: true,
				};
			},
		},
		mounted (){
			this.initData();
		},
		methods:{
			initData (){
				this.requestGetMemberRightList();
			},
			getSearchParams (){
				const params = {
					rightType: this.rightType,
					userId: this.userInfo.userId
				};

				if((window.kisDZFlag || window.oblissDZFlag || window.komoDZFlag) && this.shopDetailInfo?.custId){
					params.custId = this.shopDetailInfo.custId;
				}

				return params;
			},
			async requestGetMemberRightList (){
				this.loadView = 'view';
				
				customerReq.requestGetMemberRightList(this, this.getSearchParams()).then((res) => {

					let statistics = {
						activeNum:0,
						exhaustedNum:0,
						expiredNum:0,
						inactiveNum:0,
					};

					res.forEach((item) => {

						(item.rightsList || []).forEach((rightsItem) => {
							if(rightsItem.status===1){
								statistics.activeNum +=1;
							}
							if(rightsItem.status===2){
								statistics.inactiveNum +=1;
							}
							if(rightsItem.status===3){
								statistics.exhaustedNum +=1;
							}
							if(rightsItem.status===4){
								statistics.expiredNum +=1;
							}

							item.custId = rightsItem.custId;
						});

						if(item.saleCompId && item.custId){
							this.requestGetSyystemParamsByCodes(item);
						}
						
					});

					this.statistics = statistics;
					this.dataList = res;
					this.loadView = '';
				}).catch(() => {
					this.loadView = '';
				});				
			},
			async requestGetSyystemParamsByCodes ({saleCompId, custId}){
				let params = {
					compId:saleCompId, custId,
					paramCodes:[
						'MASE119', // 是否允许对外预约 
						'MASE291', // 允许在客户端查看权益购买价格
					]
				};
				let res = await baseReq.requestGetSystemParamsByCodes(this, params);
				this.systemInfo[saleCompId] = res.systemInfo;
			},
			setShowPage (showPage = '') {
				this.showPage = showPage;
			},
			handleItemClick (item, currencySymbol){
				this.curItem = item;
				this.currencySymbol = currencySymbol;
				this.setShowPage('rightsDetail');
			},
			handleBook (row){
				if (typeof window.showReserve == 'function') {

					window.showReserve({
						resShopInfo:{ ...row, id:row.saleCompId },
						resItemInfo: undefined,
					});
					
				}
			
			}
		}
		
	};
</script>

<style lang="less">
@import './memberRights.less';
</style>